<template>
  <div class="footer-terms__wrapper text-tiny">
    <div class="footer-terms__row">
      <div class="footer-terms__legal">
        © {{ year }} "Finance Magnates CY Ltd." All rights reserved.
      </div>
      <div class="footer-terms__links text-super-tiny">
        <a-link class="footer-terms__link" :to="linkToCookies">
          Cookie Policy
        </a-link>
        <a-link class="footer-terms__link" :to="linkToPrivacyPolicy">
          Privacy Policy
        </a-link>
        <a-link class="footer-terms__link" :to="linkToTermsOfUse">
          Terms and Conditions
        </a-link>
        <div class="footer-terms__link footer-terms__cmp-links">
          <a
            href="#"
            class="footer-terms__manage-cookies"
            @click.prevent="$_cmp_toggleCookiePreferencesPopup"
          >
            Manage Cookies
          </a>
        </div>
      </div>
    </div>
    <div class="footer-terms__do-not-sell-block text-super-tiny">
      <footer-do-not-sell-link class="footer-terms__do-not-sell-link" />
    </div>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import FooterDoNotSellLink from '@/components/_layout/AFooter/FooterTerms/FooterDoNotSellLink/index.vue'

export default {
  name: 'FooterTerms',
  components: {
    FooterDoNotSellLink
  },
  mixins: [mixins.cmp],
  data() {
    const domain = this.$helper.removeEndingSlashes(this.$env.FM_DOMAIN_URL)

    return {
      year: new Date().getFullYear(),
      linkToTermsOfUse: `${domain}/terms-of-use/`,
      linkToCookies: `${domain}/cookies/`,
      linkToPrivacyPolicy: `${domain}/privacy/`
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-terms__wrapper {
  color: $c--text-secondary;

  $margin-top: (
    $above-desktop-xl: 64px,
    $desktop-md: 24px,
    $mobile: 32px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);

  .footer-terms__row {
    display: flex;
    justify-content: space-between;

    @include tablet {
      flex-direction: column;
    }
  }

  .footer-terms__legal {
    $margin-bottom: (
      $above-desktop-xl: 0,
      $desktop-md: 12px,
      $mobile: 0
    );

    $margin-top: (
      $mobile: 26px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .footer-terms__links {
    display: flex;
    flex-wrap: wrap;

    $margin: (
      $above-desktop-xl: 0,
      $mobile: 12px 0 0
    );

    @include setStyleByBreakpoint('margin', $margin);

    .footer-terms__link {
      color: $c--text-secondary;

      @include mobile {
        margin-bottom: 4px;

        &:last-child {
          margin: 0;
        }
      }
    }

    .footer-terms__cmp-links {
      display: block;
    }
  }

  .footer-terms__manage-cookies {
    color: $c--text-secondary;
  }

  .footer-terms__do-not-sell-block {
    $margin-top: (
      $above-desktop-xl: 12px,
      $desktop-md: 12px,
      $mobile: 8px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .footer-terms__do-not-sell-link {
    display: inline-block;
  }

  .footer-terms__link {
    $margin-right: (
      $above-desktop-xl: 24px
    );

    @include setStyleByBreakpoint('margin-right', $margin-right);

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
